module.exports = __webpack_public_path__ + "static/media/zelao.6c4a7282.png";